import classNames from "classnames";
import { DisplayedMessages } from "../../../../../../common/ChatComponents/DisplayedMessages";
import { AppAccordion } from "../../../../../../shared/components/AppAcordion";
import { AppLoading } from "../../../../../../shared/components/AppLoading";
import { NoChatsLabel } from "../../../NoChatsLabel";
import { ChatObject } from "../../../../../../services/api/instances/botApi/types";
import { ChatCompletionsMessageObject } from "../../../../../../services/api/instances/completionsApi/types";
import styles from "./styles.module.css";
import { useCallback, useEffect, useState } from "react";

interface Props {
  chats: ChatObject[];
  messages: ChatCompletionsMessageObject[];
  handleClick: (chatId: string) => void;
  isMessageLoading: boolean;
  isChatBlocked: (id: string) => boolean;
  className?: string;
}

export const ChatbotMessagesLayout = ({
  chats,
  messages,
  handleClick,
  isMessageLoading,
  isChatBlocked,
}: Props) => {
  const [openAccordionId, setOpenAccordionId] = useState<string>("");

  useEffect(() => {
    setOpenAccordionId("");
  }, [chats]);

  const handleClickToAccordion = (id: string) => {
    if (openAccordionId === id) {
      setOpenAccordionId("");
      return;
    }
    setOpenAccordionId(id);
    handleClick(id);
  };

  return (
    <>
      {chats?.length === 0 ? (
        <NoChatsLabel />
      ) : (
        <div className={styles["accordion-container"]}>
          {chats?.map((chat) => {
            return (
              <AppAccordion
                key={chat.chat_id}
                className={styles.accordion}
                headerClassName={classNames({
                  [styles["accordion-blocked"]]: isChatBlocked(chat.chat_id),
                })}
                title={chat.chat_name}
                expanded={chat.chat_id === openAccordionId}
                onClick={() => {
                  handleClickToAccordion(chat.chat_id);
                }}
              >
                {isMessageLoading ? (
                  <AppLoading small />
                ) : (
                  <DisplayedMessages
                    className={styles.chat}
                    messages={messages ?? []}
                  />
                )}
              </AppAccordion>
            );
          })}
        </div>
      )}
    </>
  );
};
